export default __webpack_public_path__ + "static/media/cancel-icon-blue.46d895f6.svg";